<template>
  <b-container fluid class="study-particip-survey-page pt-30">
    <b-row>
      <b-col cols="2">
        <dl>
          <dt>Task Name</dt>
          <dd>{{ surveyName }}</dd>
        </dl>
        <hr class="mt-30 mb-30" />
        <ParticipantInfo :participantDetails="participantInfo" :surveyLocalResponseDate="surveyLocalResponseDate" :surveyLocalResponseOffset="surveyLocalResponseOffset" />
      </b-col>
      <b-col cols="8">
        <div class="docs-card mb-30">
          <div class="wrapper">
            <b-tabs content-class="mt-3">
              <div v-if="showTotalScore">
                <div class="totalScoreOldPPRLayout">
                  <span class="totalScoreText">Total Score</span>
                  <button type="button" class="fw-bold ml-10 btn btn-primary totalScoreBtnValue">
                    <span class="totalValue">{{ totalScoreValue }}</span>
                  </button>
                </div>
              </div>
              <b-tab :title="item.language" v-for="(item, index) in questions" :key="index">
                <b-list-group v-if="questions" flush class="pt-24">
                  <b-list-group-item class="item border-0 pt-0 pb-0" v-for="(ques, qIndex) in item.question" :key="qIndex">
                    <dl class="question">
                      {{ qIndex + 1 }}. {{ stripHTML(ques.questionBody) }}
                      <div class="answer">
                        <div v-if="ques.questionType == 'Image'">
                          <div v-for="(imgURL, imgIndex) in ques.imageUrls" :key="imgIndex" class="mb-15">
                            <img v-if="imgURL" class="img_response d-block" :src="imgURL" alt="image response" />
                            <div class="d-flex w-150 h-100 img-thumbnail" v-else>
                              <div class="row justify-content-center align-self-center p-52">
                                N/A
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else-if="ques.questionType == 'ImageCapture'">
                          <div class="questionInfo" v-html="ques.questionInformation"></div>
                          <div v-for="(imgURL, imgIndex) in ques.imageUrls" :key="imgIndex" class="mb-15">
                            <img v-if="imgURL" class="img_response d-block" :src="imgURL" alt="image response" />
                          </div>
                        </div>
                        <!-- Skin Analyser -->
                        <div class="answerSkin" v-else-if="ques.questionType === 'SkinAnalyser'">
                          <div class="row">
                            <div class="fRow" v-for="(item, index) of stringToJsonConvert(ques.displayAnswerText, 'Overview')" :key="index">
                              <div class="image-edit-mode d-flex flex-wrap mb-12 mr-12">
                                <div class="position-relative">
                                  <img class="image-edit-mode__image__overview" :src="item.imageURL" alt="image response" />
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="skin-left-margin">
                                <div class="row">
                                  <span class="text-redness-dryness">Redness</span>
                                </div>
                                <div class="row">
                                  <div v-for="(item, index) of stringToJsonConvert(ques.displayAnswerText, 'Redness')" :key="index">
                                    <div class="image-edit-mode d-flex flex-wrap mb-bottom mr-12">
                                      <div class="position-relative">
                                        <img class="Image-Orange-Light-Image-1" :src="item.imageURL" alt="image response" />
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="progress progress-redness mr-bottom-5">
                                        <div
                                          class="progress-bar progress-bar-redness progress-bar-success"
                                          role="progressbar"
                                          :aria-valuenow="item.imageScore"
                                          aria-valuemin="0"
                                          aria-valuemax="5"
                                          :style="{
                                            width: calculateBarWidth(item.imageScore, 5) + '%'
                                          }"
                                        >
                                          <span class="sr-only">{{ item.imageScore | decimalThreeDigit }}% Complete</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <span class="rank-redness">
                                        {{ item.imageScore | decimalThreeDigit }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="dryness-left-margin">
                              <div class="row">
                                <span class="text-redness-dryness">Dryness</span>
                              </div>
                              <div class="row">
                                <div v-for="(item, index) of stringToJsonConvert(ques.displayAnswerText, 'Dryness')" :key="index">
                                  <div class="image-edit-mode d-flex flex-wrap mb-bottom">
                                    <div class="position-relative">
                                      <img class="Image-Orange-Light-Image-1" :src="item.imageURL" alt="image response" />
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="progress progress-dryness mr-bottom-5">
                                      <div
                                        class="progress-bar progress-bar-dryness progress-bar-success"
                                        role="progressbar"
                                        :aria-valuenow="item.imageScore"
                                        aria-valuemin="0"
                                        aria-valuemax="5"
                                        :style="{
                                          width: calculateBarWidth(item.imageScore, 5) + '%'
                                        }"
                                      >
                                        <span class="sr-only">{{ item.imageScore | decimalThreeDigit }}% Complete</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <span class="rank-redness">
                                      {{ item.imageScore | decimalThreeDigit }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <span v-else-if="ques.questionType == 'GPSkin'"><JsonTree readableKeys :json="JSON.parse(ques.answerText)"/></span>
                        <span v-else v-html="ques.answerText"></span>
                      </div>
                    </dl>
                  </b-list-group-item>
                </b-list-group>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import sortBy from "lodash/sortBy";
import _ from "lodash";
import JsonTree from "@/components/common/json-tree";
import ParticipantInfo from "@/components/participants/participant-info";
import moment from "moment";
import localStorage from "@/services/localStorage";
import QlVideoUploadService from "@/services/ql-video-upload";

const MODULE_NAME = "survey";
export default {
  name: "study-participant-survey",
  components: {
    ParticipantInfo,
    JsonTree
  },
  data() {
    return {
      participantInfo: {},
      surveyName: "",
      questions: [],
      studyId: this.$route.params.studyId,
      participantId: this.$route.params.participantId,
      surveyDate: this.$route.params.surveyDate,
      trakerId: this.$route.params.trakerId,
      surveyLocalResponseDate: "",
      surveyLocalResponseOffset: "",
      totalScoreValue: "",
      showTotalScore: false,
      qlVideoUpload: null
    };
  },
  computed: {
    surveyId() {
      return this.$route.params.surveyId;
    }
  },
  methods: {
    stripHTML(data) {
      if (data == null) {
        return;
      }
      const regex = /(<([^>]+)>)/gi;
      return data.replace(regex, "");
    },
    prepareQuestions() {
      const quesCollection = [];

      quesCollection.push({ language: "English", question: this.questions });
      _.map(quesCollection[0].question, function(q) {
        if (q.questionType.toLowerCase() == "image" && q.languageImageUrls) {
          const imgUrls = _.filter(q.languageImageUrls, {
            languageCulture: "EN"
          });
          q.imageUrls = imgUrls[0].imageUrls;
          return q;
        }
      });
      if (this.participantInfo && this.participantInfo.participantLanguage) {
        const participantLang = this.participantInfo.participantLanguage.language_culture;
        if (!(participantLang == "EN")) {
          const spanishQues = _.cloneDeep(this.questions);
          _.map(spanishQues, function(q) {
            q.questionBody = q.displayQuestionText;
            q.answerText = q.displayAnswerText;
            if (q.questionType.toLowerCase() == "image" && q.languageImageUrls) {
              const imgUrls = _.filter(q.languageImageUrls, {
                languageCulture: q.displayLanguage
              });
              if (imgUrls.length) {
                q.imageUrls = imgUrls[0].imageUrls;
              }
            }
            return q;
          });
          quesCollection.push({
            language: this.participantInfo.participantLanguage.display_name,
            question: spanishQues
          });
        }
      }

      this.questions = quesCollection;
    },
    getDetails() {
      const getReq = {
        studyId: this.$route.params.studyId,
        pid: this.$route.params.participantId,
        surveyId: this.surveyId,
        responseDate: this.surveyDate
      };
      if (this.trakerId) {
        getReq.reportedDataTrackerId = this.trakerId;
      }
      this.$api.getSurvey(getReq).then(
        data => {
          this.questions = sortBy(data.responses, "sequence");
          this.prepareQuestions();
          this.surveyName = data.surveyName;
          if (data.surveyLocalResponseDate && data.surveyLocalResponseOffset) {
            const d = moment(data.surveyLocalResponseDate).utcOffset(data.surveyLocalResponseOffset);
            this.surveyLocalResponseDate = moment(d).format("DD MMMM YYYY hh:mm A");
            this.surveyLocalResponseOffset = data.surveyLocalResponseOffset ? data.surveyLocalResponseOffset : "";
            this.totalScoreValue = data.totalScore ? data.totalScore : 0;
          }
        },
        error => {
          const { message = "Error while survey request" } = (error && error.body) || {};
          this.$toastr.error(message);
        }
      );
    },
    getParticipantDetails() {
      this.$api.getParticipantDataFact(this.studyId, this.participantId).then(
        response => {
          this.participantInfo = response.body;
          this.getDetails();
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
    },
    stringToJsonConvert(stringData, type) {
      let list = [];
      if (stringData != "" || stringData != null || stringData != "undefined") {
        list = JSON.parse(stringData);
      }
      let filterList = [];
      if (type == "Overview") {
        filterList = list.filter(item => item.imageType == "overview");
      }
      if (type == "Redness") {
        filterList = list.filter(item => item.imageType == "redness");
      }
      if (type == "Dryness") {
        filterList = list.filter(item => item.imageType == "dryness");
      }
      return filterList;
    },
    calculateBarWidth(currentValue, maxValue) {
      const width = (currentValue * 100) / maxValue;
      return width;
    },
    getStudyFeatures() {
      const toggleFeatures = this.$store.getters.getStudyToggledFeatures ? this.$store.getters.getStudyToggledFeatures : JSON.parse(window.localStorage.getItem("toggledFeatures"));
      if (toggleFeatures) {
        toggleFeatures.forEach(feature => {
          if (feature.featureKey === "DISPLAY_PHQ9_SCORE") {
            this.showTotalScore = feature.enabled;
          }
        });
      }
    }
  },
  filters: {
    decimalThreeDigit(value) {
      const val = parseFloat(value).toFixed(3);
      return val > 0 ? val : 0.0;
    }
  },
  mounted() {
    this.qlVideoUpload = new QlVideoUploadService(MODULE_NAME, this.$route.params.studyId, localStorage.getItem("clientId"));
    this.getParticipantDetails();
    this.getStudyFeatures();
  }
};
</script>

<style lang="scss">
@import "~@/assets/variables.scss";
.study-particip-survey-page {
  background-color: $color_content_background;

  .docs-card {
    width: 100%;
    background-color: #fff;
    border: 1px solid #d4d9e2;
    min-height: 50px;
  }
}
dt {
  font-size: 10px;
  line-height: 1.6;
  text-transform: uppercase;
  color: #adaeb1;
}
dd {
  color: #666669;
  font-size: 14px;
  font-weight: 500;
}
.question {
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
}
.answer {
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  margin: 0;
  padding-left: 20px;
  padding-top: 0.5rem;
}
.item {
  line-height: 15px;
}
.img_response {
  width: 150px;
  height: 100px;
}
.nav-tabs {
  padding: 0px 15px;
}
.nav-tabs .nav-item {
  margin-bottom: 0px;
}
.nav-tabs .nav-link.active {
  border-color: #ffffff;
}
[tabindex="-1"]:focus {
  outline: none;
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border: none;
}
.nav-item {
  .nav-link {
    &.active {
      border-bottom: 2px solid #4c8ce4;
      font-weight: 700;
    }
  }
}
.questionInfo {
  margin: 10px 0;
  font-weight: normal !important;
}
</style>
<style scoped>
a {
  color: #495057;
}
a:hover {
  color: #495057;
}
.progress-bar-dryness {
  border: solid 1px #007bff !important;
  background-color: #007bff;
  border-radius: 10px !important;
}
.text-redness-dryness {
  font-family: Roboto-Regular;
  font-size: 12px;
  text-align: center;
  font-weight: 600;
  color: #4a4a4a;
}
.progress-bar-redness {
  background-color: #f16559;
  border: solid 1px #f16559 !important;
  border-radius: 15px !important;
}
.Image-Orange-Light-Image-1 {
  width: 66.5px;
  height: 66.5px;
  flex-grow: 0;
  margin: 0 8.8px 0 0;
}
span.rank-redness {
  width: 68px;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: -0.41px;
  text-align: center;
  color: #f16559;
}
span.rank-dryness {
  width: 68px;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: -0.41px;
  text-align: center;
  color: #007bff;
}
.image-edit-mode__image__overview {
  width: 138px;
  height: 139px;
}
.answerSkin {
  width: 100%;
  padding-left: 36px;
}
.progress {
  width: 67px !important;
  height: 9.4px;
  border-radius: 15px;
  background-color: white;
}
.skin-left-margin {
  margin-left: 14px !important;
}
.dryness-left-margin {
  margin-left: 132px !important;
  margin-top: -21px;
}
.progress-dryness {
  border: solid 1px #007bff !important;
}
.progress-redness {
  border: solid 1px #f16559 !important;
}
.mr-44 {
  margin-right: -6px !important;
}
.ml-20-red {
  margin-left: -4px !important;
}
.fRow {
  margin-left: -35px !important;
}
.mr-bottom-5 {
  margin-bottom: 5px;
}
.mb-bottom {
  margin-bottom: 2.5px;
  margin-right: -2.5px !important;
}
.totalScoreOldPPRLayout {
  float: right;
  position: relative;
  bottom: 39px;
  right: 17px;
}
.totalScoreText {
  color: #4a4a4a;
  font-weight: bold;
}
.totalScoreBtnValue {
  width: 47px;
  font-size: 12px;
}
.totalValue {
  position: relative;
  right: 1px;
}
</style>
